import { useLocation } from "wouter";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";
import { Button } from "@/components/ui/button";

export default function ProfileCompletionBanner() {
  const [, setLocation] = useLocation();
  const { user, isLoading } = useAuth();

  if (isLoading || !user) return null;
  if (user.profile_complete) return null;

  const sections = user.incomplete_sections ?? [];
  const target = sections[0];
  const href = target ? `/settings?section=${target}` : "/settings";

  return (
    <div
      role="alert"
      className="mb-6 rounded-xl border border-amber-200 bg-amber-50/80 dark:border-amber-900/40 dark:bg-amber-950/30"
    >
      <div className="flex flex-col gap-3 p-4 sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:px-5 sm:py-4">
        <div className="flex items-start gap-3 min-w-0">
          <span className="mt-0.5 inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">
            <AlertTriangle className="h-4 w-4" />
          </span>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-amber-900 dark:text-amber-200">
              Your profile is incomplete
            </p>
            <p className="mt-0.5 text-xs sm:text-sm text-amber-800/90 dark:text-amber-300/80">
              Finish setting up so your sidekick experience is fully personalised.
            </p>
          </div>
        </div>
        <div className="flex-shrink-0 sm:pl-4">
          <Button
            size="sm"
            onClick={() => setLocation(href)}
            className="bg-amber-600 text-white hover:bg-amber-700 focus-visible:ring-amber-500 dark:bg-amber-500 dark:hover:bg-amber-600 dark:text-amber-950"
          >
            Complete profile
            <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
          </Button>
        </div>
      </div>
    </div>
  );
}
